/**
 * The one label for the quote action, on every button and form submit that
 * leads to a quote (Thomas, 2026-10-01). A verb, says what the visitor gets,
 * and the same words everywhere so the action is recognized on every page.
 * The header's copy lives in site-chrome.json and must match (tested).
 */
export const QUOTE_CTA_LABEL = 'Get my quote';

/**
 * The submit button of the in-page quote card (program, category and location
 * pages). Not QUOTE_CTA_LABEL: on Oct 5 2026 two Google Ads visitors pressed
 * the card's "Get my quote" on an empty form within five minutes, reading it as
 * the header's button that opens the quote dialog. This one says it sends.
 */
export const FORM_SEND_LABEL = 'Send my request';
